import { Dayjs } from "dayjs";
import { EventGuide } from "./EventGuide";
import { EventOption } from "./ExperienceOption";
import { Note } from "./Note";
import { Order } from "./Order";
import { OrderQuantity } from "./OrderQuantity";
import { ResourceUsage } from "./ResourceUsage";
import { VirtualMeeting } from "./VirtualMeeting";

export interface Event {
    id: ID;

    /**
     * IMPORTANT: This date/time is timezone agnostic. When parsing this time, assume that UTC corresponds to the seller's timezone
     * @deprecated Use `getStart` function from `models/Event`
     */
    start: Dayjs;

    /**
     * The start date/time of this event offset with the seller's timezone.
     * Can show an incorrect date if the event is close to a DST change.
     * @deprecated Use `getStart` function from `models/Event`
     */
    actualStart: Dayjs;

    end: Dayjs;
    experience: { id: ID };
    guides: EventGuide[];
    resourceUsages: ResourceUsage[];
    seller: { id: ID };
    virtualMeeting: VirtualMeeting;
    private: boolean;
    orders: Order[];
    customerName: string;
    quantity: OrderQuantity;
    notes: Note[];
    purchaseItems: Array<{ id: ID }>;
    max?: number;
    open: number;
    title?: string;
    manual?: boolean;
    createdAt?: Dayjs;
    createdBy?: ID;
    groupId?: ID | EventGroupIdPlaceHolder;
    options?: EventOption[];
    capacityAdjustment?: EventCapacityAdjustment;
}

export interface EventCapacityAdjustment {
    createdBy: { id: ID };
    createdAt: string;
    reason?: string;
}

export enum EventGroupIdPlaceHolder {
    GROUP_ID_PRIVATE_PLACEHOLDER_EVENT = "private_placeholder",
}

export const OPEN_UNLIMITED = 99_999;
